import { AppointmentHelper } from '$components'
import { Text } from '$components'

export type DurationCellProps = {
  startDate: string
  endDate: string
}

export function DurationCell({ startDate, endDate }: DurationCellProps) {
  return (
    <Text type="s" className="text-nowrap">
      {AppointmentHelper.calculateAppointmentDuration(startDate, endDate)}
    </Text>
  )
}
